import { render } from "./AdminMenuItem.vue?vue&type=template&id=4d715c92&scoped=true"
import script from "./AdminMenuItem.vue?vue&type=script&lang=js"
export * from "./AdminMenuItem.vue?vue&type=script&lang=js"

import "./AdminMenuItem.vue?vue&type=style&index=0&id=4d715c92&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d715c92"]])

export default __exports__